import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const AnimatedComponent = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ y: 100, opacity: 0 }}
      animate={isInView ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.8, ease: "easeOut", delay }}
      className=" mx-auto"
    >
      {children}
    </motion.div>
  );
};

export default AnimatedComponent;